import { postApi } from '../utils/api';

export const inviteUserToOrg = async ({ orgId, userEmail }: { orgId: string; userEmail: string }) => {
    return postApi(`/org/${orgId}/invite`, { userEmail });
};
